import omitBy from 'lodash/omitBy';
import isUndefined from 'lodash/isUndefined';

function serializeArray(apiQuery, key, value) {
  if (Array.isArray(value)) {
    if (value.length > 0) {
      // eslint-disable-next-line no-param-reassign
      apiQuery[key] = value.join(',');
    } else {
      // eslint-disable-next-line no-param-reassign
      apiQuery.force_no_results = 'true';
    }
  } else {
    // eslint-disable-next-line no-param-reassign
    apiQuery[key] = value;
  }
}

export default function (getters, query) {
  const apiQuery = {
    api_key: window.afdcStationsOptions.apiKey,
    country: query.country,
    owner_type: query.owner,
    cards_accepted: query.payment,
    response_format: query.response_format,
  };

  if (query.page) {
    apiQuery.offset = (query.page * 10) - 10;
  }

  serializeArray(apiQuery, 'fuel_type', query.fuel);
  serializeArray(apiQuery, 'access', query.access);
  serializeArray(apiQuery, 'status', query.status);

  if (query.fuel.includes('CNG')) {
    apiQuery.cng_fill_type = query.cng_fill_type;
    apiQuery.cng_vehicle_class = query.cng_vehicle_class;
    serializeArray(apiQuery, 'cng_psi', query.cng_psis);
  } else {
    apiQuery.cng_fill_type = getters.getFilterDefaultValue('cng_fill_type');
    apiQuery.cng_vehicle_class = getters.getFilterDefaultValue('cng_vehicle_class');
    serializeArray(apiQuery, 'cng_psi', getters.getFilterDefaultValue('cng_psis'));
  }

  if (query.fuel.includes('ELEC')) {
    serializeArray(apiQuery, 'ev_charging_level', query.ev_levels);
    serializeArray(apiQuery, 'ev_connector_type', query.ev_connectors);
    serializeArray(apiQuery, 'ev_network', query.ev_networks);
  } else {
    serializeArray(apiQuery, 'ev_charging_level', getters.getFilterDefaultValue('ev_levels'));
    serializeArray(apiQuery, 'ev_connector_type', getters.getFilterDefaultValue('ev_connectors'));
    serializeArray(apiQuery, 'ev_network', getters.getFilterDefaultValue('ev_networks'));
  }

  if (query.fuel.includes('ELEC') && query.ev_connector_type_operator) {
    apiQuery.ev_connector_type_operator = query.ev_connector_type_operator;
  }

  if (query.fuel.includes('E85')) {
    apiQuery.e85_has_blender_pump = query.e85_blends;
  } else {
    apiQuery.e85_has_blender_pump = getters.getFilterDefaultValue('e85_blends');
  }

  if (query.fuel.includes('LNG')) {
    apiQuery.lng_vehicle_class = query.lng_vehicle_class;
  } else {
    apiQuery.lng_vehicle_class = getters.getFilterDefaultValue('lng_vehicle_class');
  }

  if (query.fuel.includes('HY')) {
    apiQuery.hy_is_retail = query.hy_nonretail ? 'all' : true;
  } else {
    apiQuery.hy_is_retail = true;
  }

  if (query.fuel.includes('LPG')) {
    apiQuery.lpg_include_secondary = query.lpg_secondary;
  } else {
    apiQuery.lpg_include_secondary = getters.getFilterDefaultValue('lpg_secondary');
  }

  return omitBy(apiQuery, isUndefined);
}
